import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import { CREATE_ATTRIBUTE } from './actionTypes'

export const createAttribute = (attribute: any): AppThunk => {
  return dispatch => {
    return dispatch(
      request('/organizations/:organizationId/usersattributes', CREATE_ATTRIBUTE, { method: 'POST', body: attribute })
    )
  }
}
